<h2 mat-dialog-title class="mat-dialog-title-offset">FAQs</h2>

<div class="modal-close-icon-container tw:flex tw:items-center">
    <button class="close-modal" mat-button [mat-dialog-close]="false" tabindex='-1'>
        <div class="close-modal modal-close-icon">
        </div>
    </button>
</div>

<mat-dialog-content class="mat-typography modal-master-container tw:mx-2 tw:flex tw:justify-center tw:items-center">
    <div class="tw:w-full tw:p-4 tw:m-0 tw:mt-2 content-container">

        <div class="tw:flex tw:flex-wrap tw:-mx-[15px]">
            <div class="tw:flex-1 tw:px-[15px]">
                <faq-answers [area]="data.area" [issue]="data.issue"></faq-answers>
            </div>
        </div>

    </div>

</mat-dialog-content>

<mat-dialog-actions class="div-flex-buttons">
    <div class="div-flex-buttons tw:justify-start tw:items-start">
        <button mat-button [mat-dialog-close]="false" class="btn btn-outline-primary tw:my-1 tw:mx-1 tw:float-left"
            tabindex="-1">Close</button>
    </div>
</mat-dialog-actions>